interface MatchStatusBadgeProps {
  status: string;
  className?: string;
}

/** Maps the API/logger status string to a badge-status-* CSS class suffix. */
function getStatusClass(status: string): string {
  switch (status) {
    case "Pending":
      return "badge-status-scheduled";
    case "Live_First_Half":
    case "Live_Second_Half":
      return "badge-status-in_progress";
    case "Halftime":
      return "badge-status-half_time";
    case "Fulltime":
      return "badge-status-full_time";
    case "Live_Extra_First":
    case "Extra_Halftime":
    case "Live_Extra_Second":
    case "Fulltime_Extra":
      return "badge-status-extra_time";
    case "Penalties":
      return "badge-status-penalties";
    case "Completed":
      return "badge-status-completed";
    case "Abandoned":
      return "badge-status-abandoned";
    default:
      return "badge-status-draft";
  }
}

export default function MatchStatusBadge({
  status,
  className,
}: MatchStatusBadgeProps) {
  const badgeClass = getStatusClass(status);
  const displayLabel = status.replace(/_/g, " ");

  return (
    <span className={className ? `${badgeClass} ${className}` : badgeClass}>
      {displayLabel}
    </span>
  );
}
